import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
	beforeLoad: ({ search }) => {
		// Preserve all search parameters when redirecting to calculator
		throw redirect({
			to: "/ramps/calculator",
			// biome-ignore lint/suspicious/noExplicitAny: Root route passes through unknown search params
			search: search as any, // Pass through all URL parameters
		});
	},
	component: App,
});

function App() {
	return <div>Index</div>;
}
